import { FC } from 'react';
import * as React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { ButtonProps } from './types';

type IconProp = {
  children: React.ReactNode;
};

/**
 * @summary Шаблон для кнопки в таблице.
 *
 * @param children - Иконка кнопки.
 * @param title - Всплывающее название кнопки.
 * @param onClick - Коллбэк при нажатии.
 * @param disabled - Флаг того, что кнопка отключена.
 * @param id - Id для кнопки.
 * 
 * @description Этот компонент нужен для того, чтобы можно было очень
 * быстро создавать новые кнопки с минимальным количеством кода. Плюсом
 * идёт возможность переопределить какие-либо свойства всех кнопок в одном
 * месте.
 * 
 * @example Пример добавления и использования новой кнопки:
 * // MUIButtons.tsx
 * export const Delete: FC<ButtonProps> = (props) => (
    <ButtonTemplate title={t('Remove')} {...props}>
      <DeleteIcon />
    </ButtonTemplate>
  );

  // App.tsx
    <TableMUIControls.MUIButtonGroup>
      <TableMUIControls.Delete onClick={() => console.log('Hello World!')}/>
    </TableMUIControls.MUIButtonGroup>

 */
const MUIButtonTemplate: FC<IconProp & ButtonProps> = (props) => {
  const { title, onClick, disabled, id, children } = props;

  return (
    <Tooltip title={title || ''}>
      <span>
        <IconButton onClick={onClick} disabled={disabled || false} id={id} size="small">
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default MUIButtonTemplate;
